import { useState } from 'react'
import { Angles } from '../../Util/Math/Angles'
import { Coordinates } from '../../Util/Math/Coordinates'
import { TransformTranslate } from '../../Util/Transform/Transform'
import './ChainOfFifthsCircle.scss'
import { ClassNames } from '../../Util/ClassNames'
export interface NoteCircleProps{
    radius:number
    step?:number
    referenceNote?:number
    hilitedNotes?:number[]
    selectedNotes?:number[]
    caption?:string
    onNoteClick?:Function
    height:number
    width:number
}
export function getNoteCircleRadius(radius:number){
    return radius * .3
}
export function ChainOfFifthsCircle(props:NoteCircleProps){
    return <svg className={'note-circle'} width={props.width} height={props.height}>
               <g transform={TransformTranslate(props.width/2, props.height/2)} className={'note-circle-container'}>
                    <ChainOfFifthsGroup {...props}/>
                </g>
            </svg>
}
export function ChainOfFifthsGroup(props:NoteCircleProps){
    const positionNames:number[] = [4,1,5,2,6,3,7]
    const baseRotation:number = 180
    const [rotation, setRotation] = useState(baseRotation)


    const buildNotes = function(){
        let notes:JSX.Element[] = []
        const radius:number = getNoteCircleRadius(props.radius)
        for(let i:number = 0; i < 8; i++){
            const adjustedPosition:number = (i) % 8
            let angleInDegrees:number = ((-45 * adjustedPosition) + rotation) % 360
            let angleInRadians:number = Angles.degreesToRadians(angleInDegrees)
            let x:number = props.radius * Math.sin(angleInRadians)
            let y:number = props.radius * Math.cos(angleInRadians)
            let c:Coordinates = new Coordinates(x,y)
            const position:number = positionNames[i % 8]
            const label:string = (i === 7) ? '' : String(position)
            let e:JSX.Element = <NoteCircleElement  
                                    key={i + Date.now()} 
                                    note={label} 
                                    coordinates={c} 
                                    index={i} 
                                    onClick={()=>{}}
                                    hilite={false}
                                    selected={false}
                                    isTopNote={false}
                                    noteCircleRadius={radius}
                                />
            notes.push(e)
        }
        return notes
    }
    return <g className='note-circle-group'>
                <g className={'note-circle-inner'}>{buildNotes()}</g> 
                </g>
}
export interface NoteCircleElementProps{
    noteCircleRadius:number
    coordinates:Coordinates
    index:number
    onClick:Function
    note:string
    hilite:boolean
    selected:boolean
    isTopNote:boolean
    classes?:string[]
}
export function NoteCircleElement(props:NoteCircleElementProps){
    const radius:number = props.noteCircleRadius
    let transform:string = "translate(" + props.coordinates.toStringPoints() + ")"
    const classNames:ClassNames = new ClassNames(['note-circle-element', 'shadow'])
    if(props.hilite === true) classNames.addClass('hilite')
    if(props.selected === true && !props.hilite) classNames.addClass('selected')
    if(props.note === '') classNames.addClass('ghosted')
    return <g onClick={(e:React.MouseEvent)=>{e.stopPropagation(); props.onClick(props.index)}} 
                transform={transform} 
                className={classNames.toString()}>
                    <circle r={radius}/>
                    <text fontSize={radius * 1.2}>{props.note}</text>
            </g>
}


